import { TabsContentPanel } from './TabsContentPanel';

export default TabsContentPanel;
